/**
 * @generated SignedSource<<82ca9320f612d01ccc1595411c503563>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type Console_graphQLSnippet$fragmentType: FragmentType;
export type Console_graphQLSnippet$data = {|
  +operationName: ?string,
  +query: string,
  +url: string,
  +$fragmentType: Console_graphQLSnippet$fragmentType,
|};
export type Console_graphQLSnippet$key = {
  +$data?: Console_graphQLSnippet$data,
  +$fragmentSpreads: Console_graphQLSnippet$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Console_graphQLSnippet",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "query",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "operationName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "GraphQLSnippet",
  "abstractKey": null
};

(node/*: any*/).hash = "323e463a6de36870aa06fc0126344af5";

module.exports = ((node/*: any*/)/*: Fragment<
  Console_graphQLSnippet$fragmentType,
  Console_graphQLSnippet$data,
>*/);
